<template>
  <div class="update-cooperation-com-page">
    <jw-modal v-model:visible="visible" :title="updateTitle" @cancel="handleCancel" :ok-loading="loading" title-align="start" @ok="handleOk" width="420px" :mask-closable="false">
      <jw-form :model="form" label-align="left" ref="editForm" @submit="handleSubmit">
        <jw-form-item :label="$t('群名称')" field="groupName" :rules="[{ required: true, message: $t('请输入群名称') }]" :validate-trigger="['blur', 'input', 'change']" show-colon :label-col-style="{ width: '100px' }" asterisk-position="end" label-col-flex="auto">
          <jw-input v-model="form.groupName" :placeholder="$t('请输入群名称')" allow-clear />
        </jw-form-item>
        <jw-form-item :label="$t('群成员')" field="members" :label-col-style="{ width: '100px' }" show-colon label-col-flex="auto" class="members-list">
          <p class="members-nums">{{ $t('已选') }}: {{ form.members.length }}</p>
          <div class="members-list-item" v-if="form?.members.length">
            <template v-for="(record, index) in form.members" :key="record.id">
              <div style="display: flex; margin-right: 20px">
                <xl-avatar v-if="record.collaboratorName" :avatar="{ id: record.collaboratorId, name: record.collaboratorName, url: record.collaboratorAvatar }" :size="22" />
                <span v-if="record.collaboratorId != userInfo.id && record.collaboratorType != '1'" @click="removeMembers(index)"><icon-close /></span>
              </div>
            </template>
          </div>
        </jw-form-item>
      </jw-form>
    </jw-modal>
  </div>
</template>
<script>
import { reactive, toRefs, inject, computed, ref } from 'vue';
import { clientService } from '@/api/';
import useLoading from '@/hooks/loading';
import { Message } from '@arco-design/web-vue';
import { useUserStore } from '@/store';
import { useI18n } from 'vue-i18n';
export default {
  name: 'UpdateCooperation',
  setup(props, ctx) {
    const { t } = useI18n();
    const { loading, setLoading } = useLoading(false);
    const editForm = ref();
    const { userInfo } = useUserStore(); //用户信息
    const data = reactive({
      userIds: [], //用户id
      searchData: {}, //用户列表
      id: inject('detailParams').id, //客户id,
      type: inject('detailParams').entity,
      customerName: inject('detailParams').customerName, //客户名称
      opportunityName: inject('detailParams').opportunityName, //商机名称
      detailsTitle: inject('detailParams').detailsTitle, //商机名称
      options: [
        { value: 1, label: t('读写') },
        { value: 2, label: t('只读') }
      ],
      form: {
        groupName: '',
        members: []
      },
      total: 0,
      visible: false,
      updateTitle: t('创建群组')
    });
    const cName = computed(() => data.customerName);
    const oppName = computed(() => data.opportunityName);
    const dName = computed(() => data.detailsTitle);
    console.log('userInfo', userInfo);
    data.userIds = computed(() => data.form.members?.map((el) => el.collaboratorId));
    // 组建群组
    const addGroup = async () => {
      setLoading(true);
      const params = {
        id: data.id,
        type: data.type,
        name: data.form.groupName,
        ids: data.userIds
      };
      console.log(66, params);
      try {
        const res = await clientService.creatMember(params);
        console.log(res);
        setLoading(false);
        if (res.error) {
          Message.error(res.error?.msg || t('创建失败'));
          return;
        }
        Message.success(t('创建成功'));
        data.visible = false;
        ctx.emit('cb');
      } catch (e) {
        setLoading(false);
        data.visible = false;
        Message.error(e.message || e.statusText || t('创建群组失败'));
      }
    };
    const getCollaborator = async () => {
      setLoading(true);
      data.form.members = [];
      data.total = 0;
      const params = {
        businessId: data.id,
        type: data.type,
        page: 1,
        pageSize: 10000
      };
      try {
        const res = await clientService.getMemberList(params);
        console.log(res);
        setLoading(false);
        if (res.error) {
          Message.error(res.error?.msg || t('协作人查询异常'));
          return;
        }
        data.form.members = res.result?.list;
        // data.total = res.result?.total;
      } catch (e) {
        setLoading(false);
        Message.error(e.message || e.statusText || t('协作人查询异常'));
      }
    };
    // 删除人员
    const removeMembers = (index) => {
      data.form.members.splice(index, 1);
    };
    // 详情编辑确认按钮
    const handleSubmit = ({ values, errors }) => {
      console.log('表单验证', values, errors);
      if (errors) {
        const errorArray = {};
        Object.values(errors).forEach((key, index) => {
          errorArray[key.field] = { status: 'error', message: '' };
          Object.values(errorArray).forEach((i, ind) => {
            if (index === ind) {
              i.message = key.message;
            }
          });
        });
        editForm.value.setFields(errorArray);
        data.visible = true;
        return;
      }
      addGroup();
    };
    const open = async () => {
      // editForm.value.resetFields();
      data.form.groupName = data.type == '2' || data.type == '4' || data.type == '6' || data.type == '8' || data.type == '10' || data.type == '12' ? cName.value || dName.value : data.type == '3' ? oppName.value || dName.value : dName.value;
      await getCollaborator();
      data.visible = true;
    };
    const handleCancel = () => {
      editForm.value.clearValidate();
      // editForm.value.resetFields();
      data.visible = false;
    };
    const handleOk = () => {
      editForm.value.handleSubmit();
    };

    return {
      open,
      handleCancel,
      handleOk,
      addGroup,
      editForm,
      loading,
      setLoading,
      removeMembers,
      handleSubmit,
      userInfo,
      ...toRefs(data)
    };
  }
};
</script>
<style scoped lang="less">
@import './add-group.less';
</style>
